import actions from './actions'
import getters from './getters'
import mutations from './mutations'
import state from './state'

const store = {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
}

export default store
